import { ValidateNested } from 'class-validator';
import { Expose, Type } from 'class-transformer';
import {
  ApiPropertyOptional,
  IntersectionType,
  PartialType,
  PickType,
} from '@nestjs/swagger';

import { JobDto } from './job.dto';
import { BuildingCreateDto } from '../../building/dto/building-create.dto';
import { JobCreateableInterface } from '../interfaces/job-createable.interface';
import { JobSpMappingInterface } from '../interfaces/job-sp-mapping.interface';
import { JobSpMappingDto } from './job-sp-mapping.dto';

export class JobCreateDto
  extends IntersectionType(
    PickType(JobDto, ['lot', 'address1', 'city', 'state', 'zip', 'modelId']),
    PartialType(
      PickType(JobDto, [
        'idNumber',
        'block',
        'communityPhase',
        'address2',
        'archived',
        'garageFirst',
        'highCeiling',
        'screwInspection',
        'buildingId',
        'totalSquareFootage',
        'hasTrim',
        'hasInteriorOptions',
        'interiorOptionCost',
        'hasExteriorOptions',
        'exteriorOptionCost',
        'hasTrimOptions',
        'trimOptionCost',
        'startingPhaseId',
        'startingPhaseApproved',
        'geo',
        'geoDistanceTolerance',
      ]),
    ),
  )
  implements JobCreateableInterface
{
  @ApiPropertyOptional({
    type: () => BuildingCreateDto,
    title: 'Associated Building',
    description: 'The building associated with this job',
  })
  @Expose()
  @ValidateNested()
  @Type(() => BuildingCreateDto)
  building?: BuildingCreateDto;

  @ApiPropertyOptional({
    type: () => JobSpMappingDto,
    title: 'Supply Pro Mapping',
    description: 'Supply Pro mapping',
  })
  @Expose()
  @ValidateNested()
  @Type(() => JobSpMappingDto)
  spMapping?: JobSpMappingInterface;
}
